import { useRouter } from 'next/router';
import React from 'react';
import { PictureWithFallback } from '../../sections/PictureWithFallback';
import { InitialMessageContent } from './InitialConversationContent';

type Props = {
    initialMessageContent: InitialMessageContent;
};

export const InitialConversationCard: React.FC<Props> = ({ initialMessageContent }) => {
    const router = useRouter();
    const { profileImage, conversantName, player_user_id, parent_user_id, college_id, slug } = initialMessageContent;

    return (
        <div className={`conversation-card ${router.query.show_admin_messages !== 'true' ? 'active' : ''}`}>
            <div className="image-wrapper">
                <PictureWithFallback
                    width={40}
                    height={40}
                    icon={profileImage}
                    alt={`${conversantName}'s profile picture`}
                />
            </div>
            <div className="user-info">
                <div className="username-timestamp">
                    <h2 className="username">{conversantName}</h2>
                    <p className="timestamp"></p>
                </div>
                <p className="last-message"></p>
            </div>
        </div>
    );
};
